import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import { connect } from 'react-redux';

import { getUserLead, resetUserLead } from '../redux/leads/actions';
import { getUserHistory, resetUserHistory } from '../redux/history/actions';
import { authenticateCurrentUser } from '../redux/authenticate/actions';
import { getSingleCheck } from '../redux/singleCheck/actions';
import { getChecksByProfile, resetProfileChecks } from '../redux/profileChecks/actions';
import * as selectors from '../redux/selectors';
import * as profileChecksStatus from '../redux/profileChecks/status';
import * as singleCheckStatus from '../redux/singleCheck/status';
import * as userHistoryStatus from '../redux/history/status';
import * as userLeadStatus from '../redux/leads/status';
import { flashMessage } from '../redux/flash/actions';

import { getS3Object } from '../utils/myKadImg';
import { getCompletedIn } from '../utils/time';
import { sortByDateLatest } from '../utils/sort';

import Status from '../components/Status';
import ListCollapse from '../components/ListCollapse';
import Date from '../components/Date';
import Image from '../components/Image';
import PropsLoader from '../components/PropsLoader';
import Value from '../components/Value';
import Identity from '../components/Identity';
import GetSingle from '../components/GetSingle';

import './ListItems.css';

class UserListItems extends Component {
  static propTypes = {
    leads: PropTypes.array,
    users: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    history: PropTypes.array,
    profileChecks: PropTypes.array,
    loading: PropTypes.bool,
    loadingProfileChecks: PropTypes.bool,
    loadingHistory: PropTypes.bool,
    reveal: PropTypes.string,
    icBack: PropTypes.string,
    icFront: PropTypes.string,
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  static defaultProps = {
    loading: false,
    loadingProfileChecks: false,
    loadingHistory: false,
    reveal: '',
    icBack: '',
    icFront: '',
  }

  static mapStateToProps = state => ({
    profileChecks: selectors.getChecksByProfile(state),
    userLeads: selectors.getUserLead(state),
    userHistories: selectors.getUserHistory(state),
    loading: selectors.getUserLeadLoading(state),
    loadingProfileChecks: selectors.getChecksByProfileLoading(state),
    loadingHistory: selectors.getUserHistoryLoading(state),
  })

  constructor(props) {
    super(props);
    this.state = {
      reveal: props.reveal,
      images: [],
      value: "IC Verifications",
      profileChecks: props.profileChecks,
      key: 1,
    };
  }

  async componentDidMount() {
    await this.loadImages();
  }

  componentWillUnmount() {
    this.loadImages();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profileChecks !== this.props.profileChecks) {
      this.setState({ profileChecks: nextProps.profileChecks });
    }
    if (nextProps.reveal !== this.props.reveal) {
      this.setState({ reveal: nextProps.reveal });
    }
    if (nextProps.profileChecks !== this.props.profileChecks) {
      let { profileChecks } = nextProps;
      if (profileChecks && profileChecks.length > 0) {
        profileChecks = profileChecks.sort(sortByDateLatest('createdAt'));
      }
      this.setState({ profileChecks });
    }
    if (this.props.users ||
      this.props.users.icFront !== nextProps.users.icFront ||
      this.props.users.icBack !== nextProps.users.icBack
    ) {
      this.loadImages();
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async loadImages() {
    await this.setStateAsync({ loadingImages: true });
    const { store } = this.context;
    const { users } = this.props;
    const token = await store.dispatch(authenticateCurrentUser());
    let images;
    try {
      const runImages = [];
      users.forEach((obj, idx) => {
        if (obj.icFront) {
          runImages.push(getS3Object(obj.icFront, 'icFront', token));
        }
        if (obj.icBack) {
          runImages.push(getS3Object(obj.icBack, 'icBack', token));
        }
      });
      images = await Promise.all(runImages);
    } catch (e) {
      return;
    }
    await this.setStateAsync({
      images,
      loadingImages: false,
    });
  }

  handleSelect = async (value) => {
    this.setState({value})
  }

  handleTabSelect = (key, obj) => {
    this.setState({ key }, () => {
      if (key === 1) {
        this.getLeads(obj);
        return;
      }
    });
  }

  handleViewLeads = (obj) => {
    this.setState({ revealLeads: true });
    this.getLeads(obj);
  }

  highlightLatest(i) {
    if (i === 0) {
      return 'latest';
    }
    return '';
  }

  latestCheck(i) {
    if (i === 0) {
      return 'Latest Check';
    }
    return null;
  }

  getSingleCheck = async (check, obj) => {
    const { store } = this.context;
    const body = {
      userID: obj.userID,
      checkID: check.checkID,
    };

    this.setState({
      userID: obj.userID,
      checkID: check.checkID,
    });

    const res = await store.dispatch(getSingleCheck(body));
    const { checkID, userID } = this.state;
    if (res === singleCheckStatus.SINGLECHECK_STATUS_OK) {
      window.open(`/check/cid=${checkID}&uid=${userID}`); 
      return;
    }
    store.dispatch(flashMessage('Error getting the single check. Please refresh to try again.', 'error'));
  }

  async getChecksByProfile(user = this.props.users) {
    const { store } = this.context;
    const body = {
      profileID: user.profileID,
      userID: user.userID,
    };
    const res = await store.dispatch(getChecksByProfile(body));
    if (res > profileChecksStatus.PROFILECHECK_STATUS_OK) {
      store.dispatch(flashMessage('Error getting the check by profile. Please refresh to try again.', 'error'));
      return;
    }
  }

  getUserStatus = (user) => {
    if (user.isNew) return <div className="Status new">New User</div>;
    if (user.isSuspicious) return <div className="Status error">Suspicious</div>;
    if (!user.mobileVerified) {
      if (user.hassmsIssue) {
        return (
          <span>
            <div className="Status yellow">Mobile Verification</div> <br/>
            Has SMS Issue
          </span>  
        )
      }
      return <div className="Status yellow">Mobile Verification</div>;
    }
    if (!user.incomeNetCents) return <div className="Status error">Income Incomplete</div>;
    if (!user.icVerified) {
      if (user.hasOCRIssue) {
        return (
          <span>
            <div className="Status yellow">MyKad Verification</div> <br/>
            Has OCR Issue
          </span>  
        )
      }
      return <div className="Status yellow">MyKad Verification</div>;
    }
    if (user.checkCompleted) return <div className="Status success">Credit Check Completed</div>;
    if (user.checkID) return <div className="Status orange">Credit Check Initiated</div>;
    if (user.hasCheckIssue) return <div className="Status error">Has Check Issue</div>;

    return '';
  }

  getReveal = () => {
    this.props.onReveal(this.state.reveal);
  }

  getSortedList = () => {
    const { profileChecks } = this.props;
    if (profileChecks && profileChecks.length > 0) {
      profileChecks.sort(sortByDateLatest('createdAt'));
    }

    this.setState({ profileChecks });
  }

  async getLeads(user = this.props.users) {
    const { store } = this.context;
    const body = {
      userID: user.userID,
      profileID: user.profileID,
    };
    const res = await store.dispatch(getUserLead(body));
    if (res > userLeadStatus.USERLEAD_STATUS_OK) {
      store.dispatch(flashMessage('Error getting the user leads. Please refresh to try again.', 'error'));
      return;
    }
  }

  async getHistory(user) {
    const { store } = this.context;
    const body = {
      userID: user.userID,
      profileID: user.profileID,
    };
    const res = await store.dispatch(getUserHistory(body));
    if (res > userHistoryStatus.USERHISTORY_STATUS_OK) {
      store.dispatch(flashMessage('Error getting the user history. Please refresh to try again.', 'error'));
      return;
    }
  }

  toggleShow = async (i) => {
    const { store } = this.context;
    await store.dispatch(resetUserHistory());
    await store.dispatch(resetUserLead());
    await store.dispatch(resetProfileChecks());
    this.setState({
      reveal: this.state.reveal === i ? null : i,
      revealLeads: false,
      revealProfileChecks: false,
      revealHistory: false,
    }, () => {
      this.getReveal();
      this.getSortedList();
    });
  }

  toggleHistory = (obj) => {
    this.setState({ revealHistory : true });
    this.getHistory(obj);
  }

  toggleUserCheck = (obj) => {
    this.setState({ revealProfileChecks: true });
    this.getChecksByProfile(obj);
  }

  render() {
    const { profileChecks } = this.state;
    return (
      <div className="ListItems">
        {
          [].concat(this.props.users).map((obj, i) => {
            const uploadedICFront = this.state.images.find(i => i.key === obj.icFront && i.name === 'icFront');
            const uploadedICBack = this.state.images.find(i => i.key === obj.icBack && i.name === 'icBack');
            return (
              <Row key={i}>
              <Row className="row-eq-height">
                <Col className="indexCol">{i+1}</Col>
                <Col className="createdAt">
                  <GetSingle type="check" object={obj}>
                    <Date>{obj.createdAt}</Date>
                  </GetSingle>
                </Col>
                <Col xs={3}>
                  <GetSingle type="profile" object={obj}>{obj && obj.name ? obj.name : '-'}</GetSingle> <br/>
                  <Identity type={1} identity={`${obj.nric}`} /> <br/>
                </Col>
                <Col xs={3}>{obj && obj.mobile ? obj.mobile : '-'} <br/> {obj && obj.email ? obj.email : '-'}</Col>
                <Col xs={2}>{this.getUserStatus(obj)}</Col>
                <Col className="actionCol">
                  <button className="buttonLink" onClick={() => this.toggleShow(obj.userID)}>
                    {this.state.reveal === obj.userID ? 'Hide Details' : `View User's Profile`}
                  </button>
                  <a className="buttonLink" href={`mailto:${obj.email}?Subject=[DSR-PG]`} target="_top">
                    Contact User
                  </a>
                </Col>
              </Row>
              <ListCollapse reveal={this.state.reveal === obj.userID}>
                <Row><Col xs={12}><b>Profile Details:</b></Col></Row>
                <Row>
                  <Col xs={6}>
                    <p><b>MyKad Uploaded:</b></p>
                    {
                      this.props.users && uploadedICFront ?
                      <Image inline src={uploadedICFront ? uploadedICFront.body : null} alt="icFront" loading={this.state.loadingImages}/>
                      : <div>No Front IC</div>
                    }
                    {
                      this.props.users && uploadedICBack ?
                      <Image inline src={uploadedICBack ? uploadedICBack.body : null} alt="icBack" loading={this.state.loadingImages}/>
                      : <div>No Back IC</div>
                    }
                  </Col>
                  <Col xs={3}>
                  <h4><b>Counters</b></h4>
                    <p><code>{obj.smsCount}</code>&nbsp;<b>TAC PIN Request Count(s)</b></p>
                    <p><code>{obj.ocrCount}</code>&nbsp;<b>IC Verification Count(s)</b></p>
                    <p><code>{obj.leadSubmitCount}</code>&nbsp;<b>Total Lead Submitted</b></p>
                    <p><code>{obj.rerunCount}</code>&nbsp;<b>Credit Check Request Count(s)</b></p>
                    <p><code>{obj.ocrCount}</code>&nbsp;<b>OCR Count(s)</b></p>
                    <p><code>{obj.smsCount}</code>&nbsp;<b>SMS Count(s)</b></p>
                  </Col>
                  <Col xs={3}>
                    <p><b>Total DSR Check Created</b>: <Value>{profileChecks.length}</Value></p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <b>User History</b>:
                    <button className="buttonLink" onClick={() => this.toggleHistory(obj)}>
                      View History
                    </button>
                    ({this.props.userHistories.length})
                  </Col>
                </Row>
                <div className="innerBox scrollable">
                  <PropsLoader
                    condition={this.props.userHistories.length > 0}
                    loading={this.props.loadingHistory}
                    reveal={this.state.revealHistory}
                    >
                    {
                      this.props.userHistories.length > 0 &&
                      this.props.userHistories.map((obj, i) => (
                        <Row key={i}>
                          <Col xs={2}><p><b>Created At:</b> <br /> <Date time>{obj.createdAt}</Date></p></Col>
                          <Col xs={2}>
                            <p><b>History ID:</b> <Value>{obj.historyID}</Value></p>
                            <p><b>Current State:</b> <Value>{obj.currentStat}</Value></p>
                          </Col>
                          <Col xs={2}>
                            <p><b>Profile Completed:</b> <Value>{obj.profileCompleted}</Value></p>
                            <p><b>Is Completed:</b> <Value>{obj.isCompleted}</Value></p>
                          </Col>
                          <Col xs={2}>
                            <p><b>Is New:</b> <Value>{obj.isNew}</Value></p>
                            <p><b>Type:</b> <Value>{obj.type}</Value></p>
                          </Col>
                          <Col xs={2}>
                            <p><b>Rerun Count:</b> <Value>{obj.rerunCount}</Value></p>
                            <p><b>Sms Count:</b> <Value>{obj.smsCount}</Value></p>
                          </Col>
                          <Col xs={2}>
                            <p><b>Update Income Count:</b> <Value>{obj.updateIncomeCount}</Value></p>
                            <p><b>Lead Submit Count:</b> <Value>{obj.leadSubmitCount}</Value></p>
                          </Col>

                        </Row>
                      ))
                    }
                  </PropsLoader>
                </div>
                {
                  obj.checkID &&
                    <Row>
                      <Col xs={12}>
                        <b>User Check Details</b>:
                          <button className="buttonLink" onClick={() => this.toggleUserCheck(obj)}>
                            View User’s Credit Check(s)
                          </button>
                        </Col>
                      </Row>
                }
                <div className="innerBox">
                  <PropsLoader
                    condition={this.state.profileChecks.length > 0}
                    loading={this.props.loadingProfileChecks}
                    reveal={this.state.revealProfileChecks}
                  >
                    <Row><Col xs={12}><b>Latest Check Details</b>:</Col></Row>
                    <Row>
                      <Col xs={4}>
                        <p><b>Created At</b>: <Date>{profileChecks[0] && profileChecks[0].createdAt}</Date></p>
                        <p><b>Completed At</b>: <Date>{profileChecks[0] && profileChecks[0].completedAt}</Date></p>
                        <p>Completed {getCompletedIn(profileChecks[0] && profileChecks[0].completedAt, profileChecks[0] && profileChecks[0].createdAt)}</p>
                      </Col>
                      <Col xs={4}>
                        <p><b>Loan Enquiry Submitted</b>: <Value>{profileChecks[0] && profileChecks[0].leadSubmitCount}</Value></p>
                        <p><b>Current DSR Percent</b>: <Value percent>{profileChecks[0] && profileChecks[0].dsrPercent}</Value></p>
                        <p><b>Current Income</b>: <Value money>{profileChecks[0] && profileChecks[0].incomeNetCents}</Value></p>
                        <p>
                          <b>Current Loan Eligibility</b>: &nbsp;
                            <span>
                              {
                                profileChecks[0] &&
                                profileChecks[0].loanCentsEligibleRange &&
                                <Value money>{profileChecks[0].loanCentsEligibleRange[0].minLoanAmount}</Value>
                              }
                              -
                              {
                                profileChecks[0] &&
                                profileChecks[0].loanCentsEligibleRange &&
                                <Value money>{profileChecks[0].loanCentsEligibleRange[0].maxLoanAmount}</Value>
                              }
                            </span>
                          </p>
                        </Col>
                        <Col xs={2}>
                          <button className="buttonLink" onClick={() => this.getSingleCheck(profileChecks[0], obj)}>
                            View Single Check
                          </button>
                          <br />
                          <b>Check Status:</b>
                          <Status>{profileChecks[0] && profileChecks[0].status}</Status>
                        </Col>
                      </Row>

                      <Row>
                        <Tabs
                          activeKey={this.state.key}
                          onSelect={(key) => this.handleTabSelect(key, obj)}
                          id="user-details"
                          >
                          <Tab eventKey={1} title={`Leads (${this.props.userLeads.length})`}>
                            <span>
                              {
                                !this.props.userLeads.length > 0 &&
                                <button className="buttonLink" onClick={() => this.handleViewLeads(obj)}>View Leads</button>
                              }
                            </span>
                            <PropsLoader
                              condition={this.props.userLeads && this.props.userLeads.length > 0}
                              loading={this.props.loading}
                              reveal={this.state.revealLeads}
                            >
                              {
                                this.props.userLeads.map((obj,i) => (
                                  <Row key={i}>
                                    <Col xs={2}>
                                      <p><b>Created At</b>: <Date>{obj.created_at}</Date></p>
                                      <p><b>Updated At</b>: <Date>{obj.updated_at}</Date></p>
                                    </Col>
                                    <Col xs={5}>
                                      <p><b>Lead ID</b>: {obj.leadID}</p>
                                      <p><b>Lead Loan Amount</b>: <Value money>{obj.leadLoanAmount}</Value></p>
                                      <p><b>Lead Type</b>: <Value>{obj.leadType}</Value></p>
                                    </Col>
                                    <Col xs={5}>
                                      <p><b>Income</b>: <Value money>{obj.incomeNetCent}</Value></p>
                                      <p><b>DSR</b>: <Value percent>{obj.dsrScore}</Value></p>
                                      <p><b>DSR Loan Amount</b>: <Value money>{obj.dsrLoanRange.loanAmount}</Value></p>
                                      <p><b>Eligible Loan Range</b>:
                                        <Value money>{obj.dsrLoanRange.minLoanAmount}</Value>
                                        -
                                        <Value money>{obj.dsrLoanRange.maxLoanAmount}</Value>
                                      </p>
                                      <p><b>Refinance Amount</b>: <Value>{obj.dsrLoanRange.refinanceAmount}</Value></p>
                                    </Col>
                                    <Col xs={2}>
                                      <p><b>Ownership Type</b>: <Value>{obj.ownershipType}</Value></p>
                                      <p><b>Bank ID</b>: {obj.bank && obj.bank.map((bnk, i) => (<li key={i}>{bnk}</li>))}</p>
                                      <p><b>Bank Names</b>: {obj.bankNames && obj.bankNames.map((bnk, i) => (<li key={i}>{bnk}</li>))}</p>
                                    </Col>
                                    <Col xs={3}>
                                      <p><b>Lead Status</b>: {obj.status}</p>
                                      <p><b>Reference</b>: {obj.reference}</p>
                                    </Col>
                                  </Row>
                                ))
                              }
                            </PropsLoader>
                          </Tab>
                          <Tab eventKey={2} title={`Other Checks (${this.props.profileChecks.length})`}>
                            {
                              this.props.profileChecks.map((check, i) => (
                                <Row key={i}>
                                  <Col xs={2}>
                                    <p><b>Created At</b>: <Date>{check.createdAt}</Date></p>
                                    <p><b>Last Updated</b>: <Date>{check.lastUpdated}</Date></p>
                                  </Col>
                                  <Col xs={3}>
                                    <p><b>Name</b>: {check.ccris.name}</p>
                                    <p><b>NRIC</b>: <Identity type={1} identity={`${check.ccris.nric}`} /> </p>
                                  </Col>
                                  <Col xs={3}>
                                    <p><b>Status</b>:</p> <Status>{check.status}</Status>
                                  </Col>
                                  <Col xs={3}>
                                    <button className="buttonLink" onClick={() => this.getSingleCheck(check, obj)}>
                                      View Single Check
                                    </button>
                                  </Col>
                                </Row>
                              ))
                            }
                          </Tab>
                        </Tabs>
                      </Row>
                  </PropsLoader>
                </div>
              </ListCollapse>
            </Row>
            )
          })
        }
      </div>
    );
  }
}

export default connect(UserListItems.mapStateToProps)(UserListItems);



// WEBPACK FOOTER //
// ./src/components/UserListItems.jsx